import { render } from "./Widget.vue?vue&type=template&id=f53bf67a&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"

import "./Widget.vue?vue&type=style&index=0&id=f53bf67a&scoped=true&lang=scss"

import exportComponent from "D:\\LTG Sercices\\SUP-H\\suph-adhesion-non-pro\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53bf67a"]])

export default __exports__